import type { QuickloadResponse } from './quickload.types';
import { preloadsHash } from './preloadsHash';
import { cleanPreload } from './cleanPreload';

export const waitForQuickloadUrl = (url: string) => {
  return new Promise<QuickloadResponse>((resolve, reject) => {
    const preloadObject = preloadsHash[url];
    if (preloadObject !== undefined) {
      preloadObject.used = true;
      if (preloadObject.isLoading) {
        preloadObject.callbacks.push((err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      } else {
        if (preloadObject.error) {
          reject(preloadObject.error);
        } else {
          resolve(preloadObject.data);
        }
      }
      return cleanPreload(preloadObject);
    } else {
      reject('Preload URL was never called');
    }
  });
};
